import React, { useState } from "react";
import { viewIcon } from "../../Icons/Icons";
import GeneratedEmployeeBankStatement from "./GeneratedEmployeeBankStatement";

const EmployeeBankGenerated = ({
  employeeList = [],
  selectedEmployees = [],
  setSelectedEmployees = () => {},
  selectedMonth,
  selectedYear,
}) => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isPayslipViewOpen, setIsPayslipViewOpen] = useState(false);

  const handleViewClick = (employee) => {
    setSelectedEmployee(employee);
    setIsPayslipViewOpen(true);
  };

  const handleClosePayslipView = () => {
    setSelectedEmployee(null);
    setIsPayslipViewOpen(false);
  };

  if (isPayslipViewOpen && selectedEmployee) {
    return (
      <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4 overflow-auto">
        <div className="bg-white rounded-lg shadow-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto">
          <GeneratedEmployeeBankStatement
            employee={selectedEmployee}
            onClose={handleClosePayslipView}
            selectedEmployeeIds={selectedEmployees}
            employeeList={employeeList}
            setSelectedEmployeeIds={setSelectedEmployees}
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-sm text-gray-500">
        <thead className="text-xs font-medium uppercase bg-gray-50 text-[#4B5563] border-b border-t tracking-wider">
          <tr>
            <th className="px-6 py-3 text-left border-r">Employee Serial</th>
            <th className="px-6 py-3 text-left border-r">Employee</th>
            <th className="px-6 py-3 text-left border-r">Bank Name</th>
            <th className="px-6 py-3 text-center border-r">Account Number</th>
            <th className="px-6 py-3 text-center border-r">IFSC Code</th>
            <th className="px-6 py-3 text-center border-r">Amount</th>
          </tr>
        </thead>
        <tbody>
          {employeeList.length > 0 ? (
            employeeList.map((emp, index) => {
              const empName = `${emp?.first_name} ${emp?.last_name}`;

              return (
                <tr key={index} className="bg-white border-b text-center">
                  <td className="px-6 py-4 text-left">
                    {emp?.employee_serial}
                  </td>
                  <td className="px-6 py-4 text-left">{empName}</td>
                  <td className="px-6 py-4">{emp?.bank_name}</td>
                  <td className="px-6 py-4">{emp?.account_number}</td>
                  <td className="px-6 py-4">{emp?.ifsc_code}</td>
                  <td className="px-6 py-4">{emp?.calculated_value}</td>
                  <td className="px-6 py-4 sticky right-0 bg-white z-10">
                    <div className="flex items-center justify-center gap-5">
                      <button onClick={() => handleViewClick(emp)}>
                        {viewIcon}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={8} className="text-center py-4">
                No employee data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EmployeeBankGenerated;
